var map = {
	"./icon-hotel-type0.png": "9192",
	"./icon-hotel-type1.png": "9384",
	"./icon-hotel-type2.png": "5bcf",
	"./icon-hotel-type3.png": "305a",
	"./icon-hotel-type4.png": "600c",
	"./icon-hotel-type5.png": "aa0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41ef";